import React from 'react';
import PropTypes from 'prop-types';
import { IonSegment, IonSegmentButton, IonLabel } from '@ionic/react';

function CategoryTab({ categories, onChange, value }) {
  return (
    <IonSegment
      color="secondary"
      className="menu-category-tab"
      mode="md"
      scrollable
      swipeGesture
      onIonChange={(e) => onChange(e.detail.value)}
      value={value}
    >
      {categories.map((c) => (
        <IonSegmentButton key={c.id} value={c.id}>
          <IonLabel
            color="primary"
            className={c.id === value ? 'text-bold' : ''}
          >
            {c.categoryName}
          </IonLabel>
        </IonSegmentButton>
      ))}
    </IonSegment>
  );
}

CategoryTab.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

export default CategoryTab;
